var module = angular.module('octopusApp.library');

module.controller('TagSetEditController', function($scope, $timeout, $stateParams, $state, $location, busy, pageTitle, octopusRepository, unsavedChanges, octoDialog) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var tagSetId = $stateParams["id"];

    $scope.tagSet = null;
    $scope.newTag = null;
    $scope.tagToEdit = null;
    $scope.showRemovedTagWarning = false;
    $scope.colorSet1 = ['#983230', '#A77B22', '#227647', '#52818C', '#203A88', '#752BA5', '#6e6e6e'];
    $scope.colorSet2 = ['#E8634F', '#ECAD3F', '#36A766', '#77B7C5', '#3156B3', '#9786A7', '#9d9d9d'];

    var resetTagSetEditingInProgress = function()  {
        if ($scope.tagSet != null && $scope.tagSet.Tags != null) {
            _.map($scope.tagSet.Tags, function(tag) { tag.isEditing = false; });
        }
    };

    var load = function() {
        if (tagSetId) {
            isLoading.promise(octopusRepository.TagSets.get(tagSetId).then(function (tagSet) {
                $scope.tagSet = tagSet;
                resetTagSetEditingInProgress();
                pageTitle(tagSet.Name);
            }));
        } else {
            $scope.tagSet = {};
            pageTitle('New Tenant Tag Set');
        }
        $scope.newTag = { Color: _.last($scope.colorSet1) };
    };

    $scope.selectAddColor = function(colorString) {

        $scope.newTag.Color = colorString;
        
    };

    $scope.selectEditColor = function(colorString) {

        $scope.tagToEdit.Color = colorString;

    };

    $scope.addTag = function() {

        var newTag = $scope.newTag;
        $scope.tagSet.Tags.push(newTag);

        unsavedChanges.unsaved();

        $scope.newTag = { Color: _.last($scope.colorSet1) };

    };

    $scope.editTag = function (tag) {
        resetTagSetEditingInProgress();
        $scope.tagToEdit = JSON.parse(JSON.stringify(tag)); // Simple Clone
        tag.isEditing = true;
    };

    $scope.cancelEdit = function (tag) {
        tag.isEditing = false;
    };

    $scope.updateTag = function(tag) {
        tag.Name = $scope.tagToEdit.Name;
        tag.Description = $scope.tagToEdit.Description;
        tag.Color = $scope.tagToEdit.Color;
        tag.isEditing = false;
        unsavedChanges.unsaved();
    };

    $scope.removeTag = function(tag) {
        if (tag.Id) {
            $scope.showRemovedTagWarning = true;
        }
        tag.isEditing = false;
        tag.shouldBeRemoved = true;
        unsavedChanges.unsaved();
    };

    $scope.undoRemoveTag = function(tag) {
        tag.shouldBeRemoved = false;
    };

    $scope.save = function() {
        var tagSetCopy = (JSON.parse(JSON.stringify($scope.tagSet))); //copy tagset so if save fails removed tags are still there
        tagSetCopy.Tags = _.filter(tagSetCopy.Tags, function(tag) { return !tag.shouldBeRemoved; });
        if (tagSetCopy.Id) {
            isSaving.promise(octopusRepository.TagSets.modify(tagSetCopy).then(function(tagSet){
                unsavedChanges.saved();
                $state.reload();
            }));
        } else {
            isSaving.promise(octopusRepository.TagSets.create(tagSetCopy).then(function(tagSet){
                unsavedChanges.saved();
                $location.path('/library/tagsets/' + tagSet.Id);
            }));
        }
    };


    var getTagFromTagSet = function(tagId) {
        return _.find($scope.tagSet.Tags, function(tag) { return tag.Id === tagId; });
    };

    $scope.reorder = function() {
        octoDialog.sort({
            title: "Reorder Tags",
            saveButtonText: "Update",
            load: function(dialog) {
                dialog.render(_.map($scope.tagSet.Tags, function (tag) {
                    return {
                        id: tag.Id,
                        name: tag.Name
                    };
                }));
            },
            save: function (items, dialog) {

                for (var i = 0; i < items.length; i++) {
                    var tag = getTagFromTagSet(items[i]);
                    if (tag !== undefined) {
                        tag.SortOrder = i;
                    }
                }

                $scope.tagSet.Tags = _.sortBy($scope.tagSet.Tags, 'SortOrder');
                unsavedChanges.unsaved();
                dialog.dismiss();
            }
        });
    };

    load();

});



//////////////////
// WEBPACK FOOTER
// ./app/areas/library/tagsets/controllers/tagset_edit_controller.js
// module id = 471
// module chunks = 1